import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { Icon } from 'semantic-ui-react';
import { ModalTemplate, Button as Btn } from 'components';

import { CtExamTemplateEdit } from 'containers';

import classNames from 'classnames/bind';
import styles from './ExamTemplateEditModal.css';
const cx = classNames.bind(styles);

class ExamTemplateEditModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editInvalid: false,
      editOnProgress: true,
      editSaveNow: false,
      disableSave: false,
      editSize: null,
      unSelected: true
    };
  }

  setDisableSave = value => {
    const stateObj = {};
    if (this.state.disableSave !== value) {
      stateObj.disableSave = value;
    }
    if (!value && this.state.editSaveNow) {
      stateObj.editSaveNow = false;
    }
    this.setState(stateObj);
  };

  setEditInvalid = value => {
    if (this.state.editInvalid !== value) {
      const stateObj = {
        editInvalid: value
      };
      this.setState(stateObj);
    }
  };

  setEditOnProgress = value => {
    if (this.state.editOnProgress !== value) {
      this.setState({ editOnProgress: value });
    }
  };

  setSizeToggle = () => {
    if (this.state.editSize === 'fullscreen') {
      this.setState({
        editSize: null
      });
    } else {
      this.setState({
        editSize: 'fullscreen'
      });
    }
  };

  dispatchSave = () => {
    this.setState({
      editSaveNow: true
    });
  };

  cancleAction = () => {
    const { addMode, cancleAddTemplate, mountEditModal } = this.props;
    if (addMode && typeof cancleAddTemplate === 'function') {
      cancleAddTemplate();
    }

    mountEditModal();
  };

  // 저장 버튼 활성화/비활성화 처리
  handleDisableSaveBtn = (value) => {
    this.setState({
      unSelected: value
    });
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { disableSave, editInvalid, editOnProgress, editSaveNow, editSize, unSelected } = this.state;
    const { isAuth, templateInfo, addMode, mountEditModal } = this.props;
    const { setDisableSave, setEditInvalid, setEditOnProgress, dispatchSave, cancleAction, handleDisableSaveBtn } = this;

    const { templateNo, serviceTemplateNo, serviceNo } = templateInfo;

    let HeaderText =
      defineMessages(formatMessage({ id: 'ExamTemplateEdit_5', defaultMessage: '기본 템플릿' })) +
      (addMode
        ? ' ' + defineMessages(formatMessage({ id: 'ExamTemplateEditModal_2', defaultMessage: '등록' }))
        : isAuth === 2
          ? ' (No. ' +
          templateNo +
          ') ' +
          defineMessages(formatMessage({ id: 'ExamTemplateEdit_4', defaultMessage: '수정' }))
          : ' ' + defineMessages(formatMessage({ id: 'ExamTemplateEdit_7', defaultMessage: '상세 보기 (읽기전용)' })));

    if (serviceTemplateNo) {
      HeaderText =
        defineMessages(formatMessage({ id: 'ExamTemplateEdit_2', defaultMessage: '사용자 템플릿' })) +
        ' (No. ' +
        serviceTemplateNo +
        ' / ' +
        defineMessages(formatMessage({ id: 'ExamTemplateEdit_3', defaultMessage: '서비스No' })) +
        '. ' +
        serviceNo +
        ') ';
    }

    return (
      <ModalTemplate
        size={editSize}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        className={cx('modal-template-edit', 'modal-admin', 'common-content', !!editSize ? 'full-size-modal' : '')}
        closeIcon={<Icon name="close" link onClick={cancleAction} />}
        onToggleModal={mountEditModal}
        visible
        scrolling
        header={
          <div className={cx('modal-custom-header')}>
            <div className={cx('modal-template-title')}>
              {addMode
                ? defineMessages(
                  formatMessage({ id: 'ExamTemplateEditModal_1', defaultMessage: '훈련 양식(템플릿) 등록' })
                )
                : defineMessages(
                  formatMessage({ id: 'ExamTemplateEditModal_3', defaultMessage: '훈련 양식(템플릿) 수정' })
                )}
            </div>
            <div className={cx('modal-template-subtitle')}>{HeaderText}</div>
          </div>
        }
        buttons={
          <div className={cx('inline-block', 'bt-area-right')}>
            <Btn buttonColor="#bbbbbb" onClick={cancleAction}>
              {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_4', defaultMessage: '취 소' }))}
            </Btn>
            <Btn
              className={cx('brand-button')}
              loading={editOnProgress}
              disabled={(disableSave && (editInvalid || editOnProgress)) || (!!!serviceTemplateNo && isAuth !== 2) || unSelected}
              onClick={dispatchSave}>
              {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_5', defaultMessage: '저 장' }))}
            </Btn>
          </div>
        }>
        <CtExamTemplateEdit
          addMode={addMode}
          templateInfo={templateInfo}
          editSaveNow={editSaveNow}
          setEditInvalid={setEditInvalid}
          setEditOnProgress={setEditOnProgress}
          setDisableSave={setDisableSave}
          handleOnToggleEditModal={mountEditModal}
          handleDisableSaveBtn={handleDisableSaveBtn}
        />
      </ModalTemplate>
    );
  }
}

export default injectIntl(ExamTemplateEditModal);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateEditModal.js